// Константы для компонента AllUsers
export const ROWS_PER_PAGE = 30;

// Запросы модуля - в allUsersApi.ts. Относительные пути: перехватчик axios (index.tsx) направляет их на :3001 локально
export const API_ENDPOINTS = {
  // Только для неиспользуемого UserActionsDialog.tsx (удаляется владельцем вместе с остальным легаси)
  REGIONS: '/api/regions',
  USER_DATA_UPDATE: '/api/user-data-update'
} as const;

export const SEARCH_COLUMNS = [
  { value: 'username', label: 'Логин' },
  { value: 'pharmacyNum', label: '№ аптеки' },
  { value: 'cityId', label: 'Регион' },
  { value: 'role', label: 'Роль' },
  { value: 'id', label: 'ID' },
  { value: 'userphone', label: 'Телефон' },
  { value: 'fullName', label: 'ФИО' },
  { value: 'iin', label: 'ИИН' }
] as const;
